import * as React from "react";

import AvailabilityDetails from "./AvailabilityDetails";

type Props = {
    availability: string | undefined | null;
    showAvailability: boolean;
    deliveryMode: string | undefined | null;
    deliveryDate: Date | undefined | null;
    delisted: boolean;
    storeName: string | undefined | null;
    replacementSearchLink: React.ReactNode | undefined | null;
};

// TODO(EK): Maybe just merge this into AvailabilityDetails?
export function StockPanel(props: Props) {
    const showComma = !!props.replacementSearchLink;
    return (
        <div className="mfcss_availability">
            {props.showAvailability && props.deliveryMode && props.availability && (
                <AvailabilityDetails
                    availability={props.availability}
                    deliveryMode={props.deliveryMode}
                    deliveryDate={props.deliveryDate}
                    delisted={props.delisted}
                    storeName={props.storeName}
                    showComma={showComma}
                />
            )}
            {props.replacementSearchLink}
        </div>
    );
}
